export class PatientApiService {
  constructor(http, employeeApi) {
    this.endpoint = '/patient/';
    this.http = http;
    this.employeeApi = employeeApi;
  }

  async getAll(limit, offset, search, sorts) {
    let params = {};
    if (typeof limit !== 'undefined') {
      params.per_page = limit;
    }
    if (typeof offset !== 'undefined') {
      params.page = params.page = offset === 0 ? offset / limit + 1 : offset; // offset / limit + 1;
    }
    if (typeof search !== 'undefined') {
      params.search = search;
    }
    if (typeof sorts !== 'undefined') {
      params.sorts = search;
    }
    const response = await this.http.get(this.endpoint, params);
    const data = response.data.items.map(item => ({
      id: item.id,
      ...this.serialize(item)
    }));
    return { items: data, total: response.data.total, pages: response.data.pages };
  }

  async get(uuid) {
    const response = await this.http.get(this.endpoint + uuid);
    const data = this.hasDeserialize()
      ? { ...this.serialize(response.data) }
      : response.data;
    return data;
  }

  async editPatient(uuid, data) {
    const response = await this.http.put(this.endpoint + uuid, data);
    return response.data;
  }

  async createPatient(data) {
    const response = await this.http.post(this.endpoint, data);
    return response.data;
  }

  async remove(uuid) {
    const response = await this.http.delete(this.endpoint + uuid); 
    return response;
  }

  async getSlots(params, endpoint) {
    const advurl = endpoint ? 'alltimeslot/' : 'timeslot/';
    const response = await this.http.get(this.endpoint + advurl, params); //this.endpoint + 'timeslot/', params);
    const data = response.data;
    return { items: data };
  }

  async getAppointments() {
    const response = await this.http.get(this.endpoint + 'appointment/');
    const data = response.data.map(item => {
      const employee = {
        id: item.doctor.employee.id,
        ...this.employeeApi.deserialize(item.doctor.employee)
      };
      const doctor = { ...item.doctor, employee };
      return { ...item, doctor };
    });
    return { items: data };
  }

  deserialize(form) {
    return {
      last_name: form.lastName,
      first_name: form.firstName,
      middle_name: form.middleName,
      phone: form.phone,
      email: form.email
    };
  }

  serialize(data) {
    const url = data.avatar ? process.env.VUE_APP_API_URL + '/' + data.avatar : null;
    return {
      id: data.id,
      lastName: data.last_name,
      firstName: data.first_name,
      middleName: data.middle_name,
      phone: data.phone,
      email: data.email,
      birthDay: data.date_of_birth,
      gender: data.gender === 'male' ? 'мужской' : data.gender === 'female' ? 'женский' : data.gender,
      cardid: data.cardid,
      data: data.data,
      avatar: url,
      good: data.good
    };
  }

  hasDeserialize() {
    return !(typeof this.deserialize === 'undefined');
  }
}
